import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-train-rail",
  "use": "icon-si-glyph-train-rail-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-train-rail\" id=\"icon-si-glyph-train-rail\"><title>855</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(3.000000, 0.000000)\" fill=\"#434343\"><path d=\"M1.989,16 L1.011,16 L3.011,0 L3.989,0 L1.989,16 Z\" class=\"si-glyph-fill\" /><path d=\"M10.989,16 L10.011,16 L8.011,0 L8.989,0 L10.989,16 Z\" class=\"si-glyph-fill\" /><rect x=\"0\" y=\"13\" width=\"12\" height=\"0.916\" class=\"si-glyph-fill\" /><rect x=\"0\" y=\"10\" width=\"12\" height=\"0.916\" class=\"si-glyph-fill\" /><rect x=\"1\" y=\"7\" width=\"10\" height=\"0.916\" class=\"si-glyph-fill\" /><rect x=\"1\" y=\"4\" width=\"10\" height=\"0.916\" class=\"si-glyph-fill\" /><rect x=\"2\" y=\"1\" width=\"8\" height=\"0.916\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-train-rail.svg
// module id = iB8q
// module chunks = 62